import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { CaseFormRepository } from '../../../infrastructure/repositories/case-form.repository';
import { CaseFormState } from '../../states/case-form.state';
import { GetCaseFormByCaseTypeQuery } from './get-case-form-by-case-type.query';
import { GetCaseFormByCaseTypeResult } from './get-case-form-by-case-type.result';

/**
 * Get Case Form By Case Type Use Case
 * Retrieves the case form associated with a specific case type
 * Since the relationship is 1:1, returns a single form or undefined
 */
@Injectable({ providedIn: 'root' })
export class GetCaseFormByCaseTypeUseCase {
  private readonly _repository = inject(CaseFormRepository);
  private readonly _state = inject(CaseFormState);

  public execute(query: GetCaseFormByCaseTypeQuery): Observable<GetCaseFormByCaseTypeResult> {
    this._state.setLoadingCaseForms(true);
    this._state.clearErrorCaseForms();

    return this._repository.getCaseFormByCaseTypeId(query.caseTypeId).pipe(
      catchError((error) => {
        const errorMessage = error?.error?.message || error?.message ||
          `Failed to load case form for case type ${query.caseTypeId}`;
        this._state.setErrorCaseForms(errorMessage);
        throw error;
      }),
      finalize(() => this._state.setLoadingCaseForms(false))
    );
  }
}
